<template>
    <div>
        <div class="breadcrumbs">
            <div class="col-sm-4">
                <div class="page-header float-left">
                    <div class="page-title">
                        <h1>이용직원 관리</h1>
                    </div>
                </div>
            </div>            
        </div>

        <b-container fluid class="animated fadeIn">
            <div class="card">
                <div class="card-header">
                    <strong class="card-title">필요한 내용 쓸것</strong>
                </div>
                <b-card-body>
                    <div class="mb-1 mt-2 float-left">
                        <b-button class="mb-1" size="" variant="primary" @click="showAddEmployeeForm">직원등록</b-button>
                    </div>
                                            
                    <div class="mb-1 mt-2 float-right" order="1">
                        <b-row md="4" align-v="center">
                            <b-col cols="auto" ><strong class="align-middle">이름검색:</strong></b-col>
                            <b-col><b-input type="text" placeholder="이름검색" v-model="filter"/></b-col>                                
                        </b-row>
                    </div>
                    <div class="mb-1 mt-2 mr-4 float-right" order="2" size="md">
                        <b-form-group
                            label="상태 :"
                            label-for="empState"                                    
                            :label-cols="4"
                            :horizontal="true">
                            <b-form-select size="md"  v-model="empState" :options="empStates" @change="onCustomFilter($event, dept)">
                                <option :value="null">전체</option>                            
                            </b-form-select>
                        </b-form-group>                        
                    </div>
                    <div class="mb-1 mt-2 mr-4 float-right" order="2">
                        <b-form-group
                            label="부서 :"
                            label-for="empState"                                    
                            :label-cols="4"
                            :horizontal="true">
                            <b-form-select v-model="dept" :options="departments" @change="onCustomFilter(empState, $event)">
                                <option :value="null">전체</option>                            
                            </b-form-select>
                        </b-form-group>                        
                    </div>       
                    <b-table 
                        show-empty
                        empty-text="조회된 내용이 없습니다."
                        empty-filtered-text="조회된 내용이 없습니다."
                        fixed="fixed"
                        stacked="md"                              
                        :striped="false" 
                        :bordered="true"  
                        :small="true"
                        hover                                 
                        :items="filteredItems" 
                        :fields="fields"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :filter="filter"
                        @filtered="onFiltered"
                        @row-clicked="detailEmployee">                                                                
                    </b-table>
                    <b-pagination size="md" align="center" :total-rows="totalRows" :limit="10" :hide-ellipsis="true" :per-page="perPage" v-model="currentPage" />                                  
                </b-card-body>
            </div>                    
            <b-modal id="employee-pop" 
                    ref="employeeDetail" 
                    centered 
                    size="lg"
                    title="직원 정보"
                    :ok-title="isModify ? '수정' : '등록'"
                    cancel-title="취소"
                    :no-close-on-backdrop="true"
                    :no-close-on-esc="true"
                    @hidden="initEmpInfo"
                    @ok="isModify ? updateEmpInfo($event) : addEmpInfo($event)">

                <!-- <b-container fluid v-if="employee != null">
                    
                </b-container> -->
                <b-card v-if="employee != null">                                
                        <b-form>                                    
                            <b-form-group
                            label="이름(필수)"                                    
                            label-for="empName"                                    
                            :label-cols="3"
                            :horizontal="true">
                            
                            <b-form-input id="empName" type="text" placeholder="직원명" 
                                        v-model="employee.name"
                                        data-vv-delay="500"
                                        data-vv-name="name"
                                        v-validate="'required|max:10'">                                    
                            </b-form-input>
                            <span v-show="errors.has('name')" class="text-danger">* 이름을 입력해주세요({{ errors.first('name') }})</span>
                            </b-form-group>
                            <b-form-group
                                label="성별"
                                label-for="gender"
                                :label-cols="3"
                                :horizontal="true">
                                    <b-form-radio-group
                                        id="gender"
                                        name="gender">
                                        <div class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" id="genderM" name="gender" class="custom-control-input" value="M" v-model="employee.gender">
                                            <label class="custom-control-label" for="genderM">남성</label>
                                        </div>
                                        <div class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" id="genderF" name="gender" class="custom-control-input" value="F" v-model="employee.gender">
                                            <label class="custom-control-label" for="genderF">여성</label>
                                        </div>                                    
                                    </b-form-radio-group>
                            </b-form-group>
                            <b-form-group
                            label="웹아이디"
                            label-for="webId"                                    
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-input id="webId" type="text" placeholder="로그인 아이디" 
                                        v-model="employee.webId"
                                        :readonly="isModify ? true : false"
                                        v-validate="'max:50'">
                            <span v-show="errors.has('webId')" class="c_red p-5-10">* 아이디는 30자리까지 가능합니다({{ errors.first('webId') }})</span>                                                
                            </b-form-input>
                            </b-form-group>
                            <b-form-group
                            label="패스워드"
                            label-for="webPasswd"                                    
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-input id="webPasswd" type="password" placeholder="로그인 비밀번호" 
                                        v-model="employee.webPasswd"
                                        v-validate="'max:50'">                                    
                            </b-form-input>
                            <span v-show="errors.has('webPasswd')" class="c_red p-5-10">* 비밀번호는 30자리 까지 가능합니다({{ errors.first('webPasswd') }})</span>
                            </b-form-group>

                            <b-form-group
                                label="상태"
                                label-for="state"                                    
                                :label-cols="3"
                                :horizontal="true">
                                <b-form-select v-model="employee.state" :options="empStates">                                           
                                </b-form-select>
                            </b-form-group>
                            <b-form-group
                            label="Email"
                            label-for="email"                                    
                            :label-cols="3"
                            :horizontal="true">
                                <b-form-input id="email" type="email" placeholder="이메일" 
                                            v-model="employee.email"
                                            v-validate="'email|max:60'">                                        
                                </b-form-input>
                                <span v-show="errors.has('email')" class="c_red p-5-10">* 이메일 정보를 확인해주세요({{ errors.first('email') }})</span>
                            </b-form-group> 
                            <b-form-group
                            label="차량정보"
                            label-for="carDesc"                                    
                            :label-cols="3"
                            :horizontal="true">
                                <b-form-input id="carDesc" type="text" placeholder="차량정보" 
                                            v-model="employee.carDesc"
                                            v-validate="'max:30'">                                        
                                </b-form-input>
                                <span v-show="errors.has('carDesc')" class="c_red p-5-10">* 차량 정보를 확인해주세요(30자리)({{ errors.first('carDesc') }})</span>
                            </b-form-group>   
                            <b-form-group
                                label="집주소"
                                label-for="addr"                                    
                                :label-cols="3"
                                :horizontal="true">
                                <b-input-group>
                                    <b-form-input id="addr" class="mb-2" type="text" placeholder="주소" 
                                                v-model="employee.home.addr" readonly="readonly">                                        
                                    </b-form-input>
                                    <span v-show="errors.has('addr')" class="text-danger">* 주소를입력 해주세요({{ errors.first('addr') }})</span>
                                    <b-input-group-append>
                                        <b-button id="showAddress" class="mb-2 ml-2" size="sm"                                                     
                                                @click="showDaumAddressAPI"
                                                ref="button">검색</b-button>
                                    </b-input-group-append>
                                </b-input-group>                                
                            </b-form-group> 

                            <b-form-group
                            label="전화번호(필수)"
                            label-for="phoneNo"                                    
                            :label-cols="5"
                            :horizontal="true">
                                <b-form-input id="phoneNo" type="number" placeholder="전화번호" 
                                            v-model="employee.phoneNo"
                                            data-vv-name="phoneNo"
                                            data-vv-delay="500"
                                            :readonly="isModify ? true : false"
                                            v-validate="'required|numeric|max:12'" >                                        
                                </b-form-input>
                                <span v-show="errors.has('phoneNo')" class="text-danger">* 전화번호를 입력해주세요({{ errors.first('phoneNo') }})</span>
                            </b-form-group> 
                            <!-- 
                            <b-form-group                                    
                            label="전화번호(필수)"
                            label-for="phoneNo"                                    
                            :label-cols="5"
                            :rowspan="employee.phonebook.length"
                            :horizontal="true"
                            >
                            <b-input-group  v-for="(phone, index) in employee.phonebook" :key="index">
                                <b-form-input class="mb-2" :id="'phoneNo_' + index" type="number" placeholder="전화번호"
                                            data-vv-name="phoneNo"
                                            data-vv-delay="500"
                                            v-validate="'required|numeric|max:12'" 
                                            v-model="phone.phoneNo">
                                </b-form-input>
                                <span v-show="errors.has('phoneNo')" class="text-danger">* 전화번호를 입력해주세요({{ errors.first('phoneNo') }})</span>
                                <b-input-group-append v-if="isModify">
                                    <b-button class="mb-2 ml-2" size="sm" @click="modifyPhoneNo(employee.pid, phone)">변경</b-button>
                                </b-input-group-append>
                                <b-input-group-append v-if="isModify">
                                    <b-button class="mb-2 ml-2" size="sm" @click="removePhoneNo(employee.pid, phone, index)">삭제</b-button>
                                </b-input-group-append>
                            </b-input-group>
                            <b-input-group v-if="isModify">
                                <b-form-input class="mb-2" id="new_phoneNo" type="number" placeholder="전화번호 추가" 
                                            v-model="newPhoneNo">
                                </b-form-input>
                                <b-input-group-append>
                                    <b-button class="mb-2 ml-2" size="sm" variant="primary" @click="addPhoneNo(employee.pid)">추가</b-button>
                                </b-input-group-append>
                            </b-input-group>
                             
                            </b-form-group>
                            -->
                            <b-form-group
                            id="deptContainer"
                            label="부서"
                            label-for="deptName"                                    
                            :label-cols="5"
                            :horizontal="true">
                            <b-input-group>                                    
                                <b-form-input class="mb-2" id="deptName" type="text" placeholder="부서명" 
                                            :readonly="true"
                                            v-model="employee.deptName"
                                            data-vv-name="deptName"
                                            data-vv-delay="500"
                                            v-validate="'required'">
                                </b-form-input>
                                <span v-show="errors.has('deptName')" class="text-danger">* 부서를 선택해주세요({{ errors.first('deptName') }})</span>
                                <b-input-group-append>
                                    <b-button id="showDeptBtn" class="mb-2 ml-2" size="sm"                                                     
                                            @click="showDepartment"
                                            ref="button">보기</b-button>
                                </b-input-group-append>
                                <b-popover target="showDeptBtn"
                                            triggers="click"                                                    
                                            :show.sync="popoverShow"
                                            placement="right"
                                            container="deptContainer"
                                            ref="popover"
                                            title="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;부서목록&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
                                            @show="onShow"
                                            @shown="onShown"
                                            @hidden="onHidden">
                                    
                                    <div>                                                
                                        <b-form-group label="부서" label-for="dept"
                                                    :label-cols="3"
                                                    horizontal class="mb-2"                                                            
                                                    invalid-feedback="This field is required">
                                        <b-form-select size="sm" id="dept" v-model="selectedDept" :options="options" @change="selectedDepartmentByPopover($event)"/>
                                        </b-form-group>                                                
                                        <b-btn @click="onClose" size="sm" variant="danger">닫기</b-btn>                                                
                                    </div>
                                    </b-popover>
                            </b-input-group>
                            </b-form-group>
                            <b-form-group
                            label="직책"
                            label-for="positionName"                                    
                            :label-cols="5"
                            :horizontal="true">
                                <b-form-input id="positionName" type="text" placeholder="직책" 
                                            v-model="employee.positionName"
                                            v-validate="'max:10'">                                        
                                </b-form-input>
                                <span v-show="errors.has('positionName')" class="c_red p-5-10">* 직책명을 입력해주세요({{ errors.first('positionName') }})</span>
                            </b-form-group> 
                            <b-form-group
                            label="차량정보(타입)"
                            label-for="carType"
                            :label-cols="5"
                            :horizontal="true">
                                <b-form-radio-group
                                id="carType"
                                name="carType">
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="carType10171" name="carType" class="custom-control-input" value="10171" v-model="employee.carType">
                                    <label class="custom-control-label" for="carType10171">승용차</label>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="carType10172" name="carType" class="custom-control-input" value="10172" v-model="employee.carType">
                                    <label class="custom-control-label" for="carType10172">승합차</label>
                                </div>         
                                </b-form-radio-group>
                            </b-form-group>
                            <b-form-group
                            label="차량정보(수동/자동)"
                            label-for="carManualState"
                            :label-cols="5"
                            :horizontal="true">
                                <b-form-radio-group
                                id="carManualState"
                                name="carManualState">
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="manualStateN" name="carManualState" class="custom-control-input" value="N" v-model="employee.manualState">
                                    <label class="custom-control-label" for="manualStateN">자동</label>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="manualStateY" name="carManualState" class="custom-control-input" value="Y" v-model="employee.manualState">
                                    <label class="custom-control-label" for="manualStateY">수동</label>
                                </div>                                                                             
                                </b-form-radio-group>
                            </b-form-group>
                            <!--
                            <b-form-group
                            label="차량정보(상세)"
                            label-for="carDesc"                                    
                            :label-cols="5"
                            :horizontal="true">
                                <b-form-input id="carDesc" type="text" placeholder="차량 상세 정보" 
                                            v-model="employee.carInfo.carDesc"
                                            v-validate="'max:50'">                                        
                                </b-form-input>
                            </b-form-group>
                            -->
                            <b-form-group
                            label="한도횟수"
                            label-for="useLimitCnt"                                    
                            :label-cols="5"
                            :horizontal="true">
                            <b-form-input id="useLimitCnt" type="number" placeholder="한도횟수" v-model="employee.limitOption.useLimitCnt"></b-form-input>
                            </b-form-group>
                            <b-form-group
                            label="한도금액"
                            label-for="useLimitAmount"                                    
                            :label-cols="5"
                            :horizontal="true">
                            <b-form-input id="useLimitAmount" type="number" placeholder="한도금액" v-model="employee.limitOption.useLimitAmount"></b-form-input>
                            </b-form-group>
                            <b-form-group
                            label="한도초과시접수여부"
                            label-for="overLimitPermitYN"
                            :label-cols="5"
                            :horizontal="true">
                            <b-form-radio-group
                            id="overLimitPermitYN"
                            name="overYN">
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" id="overY" name="overYN" class="custom-control-input" value="Y" v-model="employee.limitOption.overLimitPermitYN">
                                <label class="custom-control-label" for="overY">허용</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" id="overN" name="overYN" class="custom-control-input" value="N" v-model="employee.limitOption.overLimitPermitYN">
                                <label class="custom-control-label" for="overN">허용안함</label>
                            </div>                                    
                            </b-form-radio-group>
                        </b-form-group>                                    
                        </b-form>
                    </b-card>
            </b-modal>  
        </b-container><!-- .content -->
    </div>
</template>
<script>
import {managedEmp, department} from '../data/table.js'
import employeeApi from '../api/employee'
import kakaoApi from '../api/kakao'
import departmentApi from '../api/department'
import ResultMessage from '../data/resultMessage'
import {mapGetters} from 'vuex'
import _ from 'lodash';

export default {    
    name: 'MngrEmployee',        
    data() {
        return {
            fields: managedEmp.fields,            
            items: [],            
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            filter: null,
            employee: null,
            newPhoneNo: null,
            isModify: false,
            departments: [],
            deptFields: department.fields,
            deptTotalRows: 0,
            deptPerPage: 5,
            deptCurrentPage: 1,
            deptNameFilter: null,
            popoverShow: false,
            selectedDept: null,
            options: [],
            filteredItems: [],
            empState: null,
            dept: null,
            empStates: [
                {
                    value: 10931,
                    text: '이용가능'
                },
                {
                    value: 10932,
                    text: '이용불가'
                },
                {
                    value: 10933,
                    text: '퇴사'
                }
            ]
        }
    },
    computed: {
        ...mapGetters({
            userAccount: 'userAccount/userAccount'    
        })
    },
    // computed: mapGetters({
    //     userAccount: 'userAccount/userAccount'
    // }),
    methods : {
        // 직원 정보 초기화(등록시 필요))
        initEmployee: function() {
            return {
                name: null,
                gender: 'M',
                webId: null,
                webPasswd: null,
                email: null,
                positionName: null,
                corpNo: this.userAccount.corpNo,
                carType: 10171,
                manualState: 'N',                
                phoneNo: null,  
                state: 10931,            
                home: {
                    addr: null,
                    dspAddr: null,
                    lat: 0.0,
                    lon: 0.0,
                    name: '집'
                },
                deptNo: null,
                deptName: null,
                deptLimit: {
                    deptName: null
                },
                limitOption: {
                    overLimitPermitYN: 'Y',
                    useLimitCnt: null,
                    useLimitAmount: null
                }
            }
        },
        // 직원 등록 폼 초기화
        showAddEmployeeForm: function() {
            this.employee = this.initEmployee();
            this.$refs.employeeDetail.show();
        },
        // 직원 정보 상세
        detailEmployee: function(item, index, event) {
            event.preventDefault();
            let employeeNo = item.memberNo;                        
            let resultMessage = new ResultMessage();

            employeeApi.employeeInfo(this.userAccount.corpNo, employeeNo)
            .then(response => {
                resultMessage.buildSuccessMessage(response);                
                this.employee = resultMessage.payload;
                if(resultMessage.payload != null) {
                    let addrs = resultMessage.payload.addressList;
                    if(addrs != null && addrs.length > 0) {                        
                        let addr = addrs[0];
                        this.employee.home = addr;
                    } else {
                        this.employee.home = {
                                                addr: null,
                                                dspAddr: null,
                                                lat: 0.0,
                                                lon: 0.0,
                                                name: '집'
                                             }
                    } 
                    this.employee.deptNo = this.employee.dept.pid;
                    this.employee.deptName = this.employee.dept.deptName;   
                    this.employee.phoneNo = this.employee.phones[0].phoneNo;
                }

                this.isModify = true;
                this.$refs.employeeDetail.show();
            })
        },
        
        addEmpInfo: async function(event) {
            event.preventDefault();
            if(this.employee == null) {
                alert('등록할 내용이 없습니다.');
                return;
            }
            if(confirm('등록하시겠습니까?') == false ) return;

            // 좌표정보(카카오 API)
            if(this.employee.home.addr != false) {                
                let kakaoResponse = await kakaoApi.getCoordinate(this.employee.home.addr);                
                if(kakaoResponse.data != false) {  
                    if(kakaoResponse.data.meta.total_count > 0) {
                        let document = kakaoResponse.data.documents[0];                        
                        this.employee.home.lat = document.x;
                        this.employee.home.lon = document.y; 
                    }
                }
            }
            this.$validator.validateAll()
            .then(success => {
                if(success == false) {
                    alert('필수 항목을 입력해 주세요');
                    return;
                }                
                    
                let resultMessage = new ResultMessage();                

                employeeApi.addEmployee(this.employee).then(response => {                    
                    alert('등록 되었습니다.');
                    this.listEmployee();
                    this.$refs.employeeDetail.hide();
                }).catch(error => {
                    resultMessage.buildErrorMessage(error);
                    alert(resultMessage.message);
                })
            })
        },
               
        // 직원 정보 수정
        updateEmpInfo: function(event) {
            event.preventDefault();
            if(this.employee == null) {
                alert('변경할 내용이 없습니다.')
                return;
            }

            if(confirm('변경하시겠습니까?') == false) return;
            let resultMessage = new ResultMessage();

            this.$validator.validateAll()
            .then(success => {
                if(success == false) {
                    alert('필수 항목을 모두 입력해주세요');
                    return;
                }
                
                employeeApi.modifyEmployee(this.employee).then(response => {
                    alert('변경되었습니다.');                    
                    this.$refs.employeeDetail.hide();                    
                    this.listEmployee();
                }).catch(error => {
                    resultMessage.buildErrorMessage(error);
                    alert(resultMessage.message);
                })
            }).catch(error => {
                console.log(error)
            });

        },
        departmentList: function() {
            let resultMessage = new ResultMessage();         
            departmentApi.departmentList(this.userAccount.corpNo).then(response => {
                resultMessage.buildSuccessMessage(response);
                resultMessage.payload.forEach(o => {
                    let dept = {};
                    dept.text = o.deptName;
                    dept.value = o.pid;
                    this.departments.push(dept);
                })                

            }).catch(error => {
                resultMessage.buildErrorMessage(error);
                alert(resultMessage.message);
            });

            return resultMessage;
        },
        // 부서보기
        showDepartment: function(item, index, event) {   
            let resultMessage = new ResultMessage();         
            departmentApi.departmentList(this.userAccount.corpNo).then(response => {
                resultMessage.buildSuccessMessage(response);
                
                resultMessage.payload.forEach(o => {
                    let dept = {};
                    dept.text = o.deptName;
                    dept.value = o.pid;
                    this.options.push(dept);
                })
                this.popoverShow = true;
            }).catch(error => {
                resultMessage.buildErrorMessage(error);
                alert(resultMessage.message);
            })
        },
        // 부서 선택
        selectedDepartment: function(item, index, event) {
            event.preventDefault();
            this.employee.deptNo = item.pid;
            this.employee.deptName = item.deptName;
            this.$forceUpdate();
            this.$refs.departmentList.hide();
        },
        selectedDepartmentByPopover: function(e) {
            
            if(e == '') return;
            this.employee.deptNo = e;
            let dept = _.find(this.options, (o) => {
                return o.value == e;
            });
            
            this.employee.deptName = dept.text;            
            this.onClose();
            this.$forceUpdate();
            this.$refs.departmentList.hide();
        },
        //직원 목록
        listEmployee: function() {
            let resultMessage = new ResultMessage();
            employeeApi.employeeList(this.userAccount.corpNo).then(response => {
                resultMessage.buildSuccessMessage(response);
                this.items = resultMessage.payload;
                this.filteredItems = this.items;
            }).catch(error => {
                resultMessage.buildErrorMessage(error);
                alert(resultMessage.message);
            });
        },
        // 전화번호 변경
        modifyPhoneNo: function(empNo, phone) {
            if(confirm('수정하시겠습니까?') == false) return;
            let resultMessage = new ResultMessage();
            employeeApi.modifyPhoneNo(phone.pid, empNo, phone.phoneNo).then(response => {
                alert('변경되었습니다.');
            }).catch(error => {
                resultMessage.buildErrorMessage(error);
                alert(resultMessage.message);
            });
        },
        // 전화번호 등록
        addPhoneNo: function(empNo) {
            if(this.newPhoneNo == null) {
                alert('추가 등록할 전화번호를 입력해 주세요');
                return;
            }
            
            if(confirm('등록하시겠습니까?') == false) return;

            let resultMessage = new ResultMessage();
            employeeApi.addPhoneNo(empNo, this.newPhoneNo).then(response => {
                resultMessage.buildSuccessMessage(response);                
                this.employee.phonebook.push(resultMessage.payload);
                this.newPhoneNo = null;
                alert('등록 되었습니다.');
                this.$forceUpdate();
            }).catch(error => {
                resultMessage.buildSuccessMessage(error);
                alert(error.message);
            })
        },
        // 전화번호 삭제
        removePhoneNo: function(empNo, phone, index) {
            if(confirm('삭제 하시겠습니까?') == false)  return;
            employeeApi.removePhoneNo(phone.pid, empNo).then(response => {
                alert('삭제 되었습니다.');
                this.employee.phonebook.splice(index, 1);
                this.$forceUpdate();
            }).catch(erorr => {
                console.log('error remove phoneNo....');
            })
        },
        // 직원 정보 초기화
        initEmpInfo: function() {      
            this.employee = null;
            this.newPhoneNo = null;
            this.isModify = false;
        },
        onFiltered (filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering            
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        onCustomFilter(state, dept) {   
                       
            if(state != null && dept != null) {
                this.filteredItems = _.filter(this.items, function(v, k){                   
                    return (v.state == state) && (v.deptNo == dept);
                })                
            } else {
                if(state != null){
                    this.filteredItems = _.filter(this.items, function(v, k){                   
                        return v.state == state;
                    })                
                } else if(dept != null) {
                    this.filteredItems = _.filter(this.items, function(v, k){                   
                        return v.deptNo == dept;
                    })
                } else {                
                    this.filteredItems = this.items;
                }
                this.totalRows = this.filteredItems.length;
                this.currentPage = 1;                
            }            
        },
        onFilteredDept(e) {
            if(e != null){
                 this.filteredItems = _.filter(this.items, function(v, k){                   
                    return v.deptNo == e;//!v.selected && v.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1
                })                
            } else {                
                this.filteredItems = this.items;
            }
            this.totalRows = this.filteredItems.length;
            this.currentPage = 1  
        },
        onDeptNameFiltered(filteredItems) {
            this.deptTotalRows = filteredItems.length;
            this.deptCurrentPage = 1;
        },
        onClose () {
            this.popoverShow = false;
            this.options = [];
            this.selectedDept = null;
        },
        onShown () {
            this.focusRef(this.$refs.selectedDept);
        },
        onShow () {
            this.selectedDept = null;
        },
        onHidden () {
            this.focusRef(this.$refs.button);
        },
        focusRef (ref) {
            /* Some references may be a component, functional component, or plain element */
            /* This handles that check before focusing, assuming a focus() method exists */
            /* We do this in a double nextTick to ensure components have updated & popover positioned first */
            this.$nextTick(() => {
                this.$nextTick(() => { (ref.$el || ref).focus() });
            });
        },
        showDaumAddressAPI : function() {
          var vm = this;
          new daum.Postcode({
            oncomplete: function(data) {
                // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

                // 도로명 주소의 노출 규칙에 따라 주소를 조합한다.
                // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.                
                //var address = data.roadAddress == '' ? data.jibunAddress : data.roadAddress; // 도로명 주소 변수                               
                vm.employee.home.addr = data.userSelectedType == 'J' ? data.jibunAddress : data.roadAddress;
                
                self.close();
            }
            }).open();
        }
    },
    created: function(){        
        
    },
    mounted: function() {
        this.listEmployee();        
        this.departmentList();
    }
}
</script>
<style lang="scss" scoped>
@import '../assets/css/lib/datatable/dataTables.bootstrap.min.css';
</style>



// WEBPACK FOOTER //
// src/components/MngrEmployee.vue